<template>
  <div class="home-con">
    <Row>
      <ciCdUpcoming v-show="homeModule.ciCdUpcoming" :panelShow="homeModule.ciCdUpcoming" :colSpanBig="colSpanBig"></ciCdUpcoming>
      <alarmList v-show="homeModule.alarmList" :panelShow="homeModule.alarmList" :colSpanBig="colSpanBig"></alarmList>
      <serverCount v-show="homeModule.serverCount" :panelShow="homeModule.serverCount" :colSpan="colSpan"></serverCount>
      <alarmCount v-show="homeModule.alarmCount" :panelShow="homeModule.alarmCount" :colSpan="colSpan"></alarmCount>
      <alarmChartModal ref="alarmChartModal"></alarmChartModal>
    </Row>
    <Row>
      <MonitorOverview v-show="homeModule.MonitorOverview"
                       :panelShow="homeModule.MonitorOverview"
                       :defaultEndpoint="homeMonitorOverviewDefaultEndpoint"></MonitorOverview>
    </Row>
    <Row>
      <MonitorBoard v-show="homeModule.MonitorBoard" :panelShow="homeModule.MonitorBoard"></MonitorBoard>
    </Row>
  </div>
</template>

<script>
import ciCdUpcoming from './components/ci-cd-upcoming'
import alarmList from './components/alarm-list'
import serverCount from './components/server-count'
import alarmCount from './components/alarm-count'
import MonitorBoard from './components/monitor-board'
import alarmChartModal from '../../view/monitor/components/chart-modal'
import MonitorOverview from './components/monitor-overview'
import { getHomeConfig } from '@/api/settings'

export default {
  name: 'home',
  components: {
    MonitorBoard,
    ciCdUpcoming,
    alarmList,
    serverCount,
    alarmCount,
    alarmChartModal,
    MonitorOverview
  },
  data () {
    return {
      homeModule: {
        ciCdUpcoming: false,
        alarmList: false,
        serverCount: false,
        alarmCount: false,
        MonitorOverview: false,
        MonitorBoard: false
      },
      homeMonitorOverviewDefaultEndpoint: ''
    }
  },
  created: function () {
    this.getHomeModuleList()
  },
  computed: {
    modulesArr: function () {
      let ret = []
      // 将这几个模块的true或者false的值放到一个数组中
      for (let key in this.homeModule) {
        if (this.homeModule[key]) {
          ret.push(key)
          ret.forEach((item, index) => {
            if (item === 'MonitorOverview') {
              delete ret[index]
            } else if (item === 'MonitorBoard') {
              delete ret[index]
            }
          })
          ret = ret.filter(function (val) {
            return val
          })
        }
      }
      return ret
    },
    colSpanBig: function () {
      // 这里最重要的是把 3和4看成是一个整体来思考，当大于3的时候，说明是全选，length的最大长度是3，每个模块是8等分
      let length = this.modulesArr.length > 3 ? 3 : this.modulesArr.length
      let ciCdUpcoming = this.modulesArr.indexOf('ciCdUpcoming')
      let alarmList = this.modulesArr.indexOf('alarmList')
      let serverCount = this.modulesArr.indexOf('serverCount')
      let alarmCount = this.modulesArr.indexOf('alarmCount')
      // 一二中一个显示，且三四都不显示。占满24
      if ((ciCdUpcoming !== -1 && alarmList === -1 && serverCount === -1 && alarmCount === -1) || (ciCdUpcoming === -1 && alarmList !== -1 && serverCount === -1 && alarmCount === -1)) {
        length = 1
      }
      // 一二中一个显示，且三四都显示。占一半12
      if ((ciCdUpcoming !== -1 && alarmList === -1 && serverCount !== -1 && alarmCount !== -1) || (ciCdUpcoming === -1 && alarmList !== -1 && serverCount !== -1 && alarmCount !== -1)) {
        length = 2
      }
      // 一二都显示，占一半12
      if (ciCdUpcoming !== -1 && alarmList !== -1) {
        length = 2
      }
      // 显示二三
      if (ciCdUpcoming === -1 && alarmList !== -1 && serverCount !== -1 && alarmCount === -1) {
        length = 1
      }
      // 显示二四
      if (ciCdUpcoming === -1 && alarmList !== -1 && serverCount === -1 && alarmCount !== -1) {
        length = 1
      }
      // 全部显示占8
      if (ciCdUpcoming !== -1 && alarmList !== -1 && serverCount !== -1 && alarmCount !== -1) {
        length = 3
      }
      return 24 / length
    },
    colSpan: function () {
      // 这里最重要的是把 3和4看成是一个整体来思考，当大于3的时候，说明是全选，length的最大长度是3，每个模块是8等分
      let length = this.modulesArr.length > 3 ? 3 : this.modulesArr.length
      let ciCdUpcoming = this.modulesArr.indexOf('ciCdUpcoming')
      let alarmList = this.modulesArr.indexOf('alarmList')
      let serverCount = this.modulesArr.indexOf('serverCount')
      let alarmCount = this.modulesArr.indexOf('alarmCount')
      // 占满24
      if ((serverCount !== -1 && alarmCount === -1) || (serverCount === -1 && alarmCount !== -1)) {
        length = 1
      }
      // 占一半12
      if (serverCount !== -1 && alarmCount !== -1) {
        length = 2
      }
      // 全部显示占8
      if (ciCdUpcoming !== -1 && alarmList !== -1 && serverCount !== -1 && alarmCount !== -1) {
        length = 3
      }
      return 24 / length
    }
  },
  methods: {
    getHomeModuleList () {
      getHomeConfig().then(res => {
        let result = res.data
        if (result.homeModule) {
          for (let component in result.homeModule) {
            if (result.homeModule.hasOwnProperty(component)) {
              this.homeModule[component] = result.homeModule[component]
            }
          }
        } else {
          this.homeModule = {
            ciCdUpcoming: true,
            alarmList: true,
            serverCount: true,
            alarmCount: true,
            MonitorOverview: true,
            MonitorBoard: true
          }
        }
        if (result.homeMonitorOverviewDefaultEndpoint) {
          this.homeMonitorOverviewDefaultEndpoint = result.homeMonitorOverviewDefaultEndpoint
        }
      }).catch(res => {
        this.homeModule = {
          ciCdUpcoming: true,
          alarmList: true,
          serverCount: true,
          alarmCount: true,
          MonitorOverview: true,
          MonitorBoard: true
        }
      })
    }
  }
}
</script>

<style>
  .home-card {
  background-color: #1E1C1D;
  color: #fff;
  }
  .home-card .ivu-card-head {
    border-bottom: 1px solid #333;
  }
  .home-component-loading {
    background-color: rgba(30, 28, 29, 0.9);
  }
</style>
